<template>
	<div class="mt-tootip">
		<div class="mt-tooltip">{{cutString(content,countCut)}}
			<span class="mt-tooltip__tooltiptext">{{content}}</span>
		</div>
	</div>
</template>

<script>


export default {
	name: 'mt-tootip',
	props: {
		content: {
			type: String,
			default: ''
		},
		countCut: {
			type: Number,
			default: 20
		}
	},
	components: {

	},

	data () {
		return {
			
		}
	},
	computed: {

	},
	methods: {
		cutString (str, len) {
			if(str.length >= len){
				return str.substr(0,len)+"...";
			}
			return str
		}
	},
	created () {
		
	},
	mounted () {
		
	},
	
	
	
}
</script>




// WEBPACK FOOTER //
// Tooltip.vue?5c2a21ee